import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContactInformation } from './contact-information.model';
import { stepContactInformationBuilderUI } from './contact-information.mappers';
import { format } from '@shared/utilities/formatEmail';

@Injectable({
  providedIn: 'root'
})
export class ContactInformationService {
  constructor(private _http: HttpClient) {}
  baseUrl = environment.apiUrl;

  setContactInformation(info, userName): Observable<ContactInformation> {
    return this._http
      .post(`${this.baseUrl}/users/${format(userName)}/contact-info`, info)
      .pipe(map(stepContactInformationBuilderUI));
  }

  getContactInformation(userName): Observable<ContactInformation> {
    return this._http
      .get(`${this.baseUrl}/users/${format(userName)}/contact-info`)
      .pipe(map(stepContactInformationBuilderUI));
  }
}
